import { render } from "./my-team-breadcrumbs.vue?vue&type=template&id=01ca040d&ts=true"
import script from "./my-team-breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./my-team-breadcrumbs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__